import { Component } from '@angular/core';
import { NavbarComponent } from "../../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../../partials/footer/footer.component";
import { Title } from '@angular/platform-browser';
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'app-tire-knowledge',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './tire-knowledge.component.html',
  styleUrl: './tire-knowledge.component.css'
})
export class TireKnowledgeComponent {
  texts: any;
  constructor(private langService:LanguageService, private title:Title){
    this.texts = this.langService.getWebisteTexts().tire_knowledge;
  
    if (this.langService.getLanguage() == 'es') {
      this.title.setTitle('PRINX - Información sobre llantas');

    }else{
      this.title.setTitle('PRINX - Tire Information');
    }
  }
}
